/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const KeyIcon = ({ width = 24, height = 24, hidden = false, title = 'Key' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2.07324,12.66797c1.10938-1.32324,3.2428-1.46875,5.01636-.44189L15.65625,1.43164c.25781-.32422.73047-.37695,1.05371-.12207.3252.25781.37891.72949.12207,1.05371l-.56079.70654,2.21118,1.85596c.1543.12891.25.31543.26562.5166.01562.2002-.05078.39941-.18262.55078l-2.10742,2.41504c-.14844.16992-.35645.25684-.56543.25684-.1709,0-.3418-.05762-.48242-.17578l-2.06458-1.73291-.62207.78394,2.04504,1.71558c.31738.26562.3584.73926.0918,1.05664-.14844.17676-.36035.26758-.57422.26758-.1709,0-.3418-.05762-.48242-.17578l-2.01294-1.68872-3.52551,4.44214c.70203.73657,1.15637,1.62744,1.2533,2.5415.0918.87305-.14746,1.69922-.6748,2.32812-.62598.74512-1.5791,1.11914-2.60938,1.11914-1.01172,0-2.09766-.36035-3.02051-1.08203-1.0332-.80762-1.69434-1.92773-1.81445-3.07129-.09082-.87207.14844-1.69824.67383-2.3252ZM15.81152,6.86719l1.12109-1.28418-1.59412-1.33789-1.06018,1.33582,1.5332,1.28625ZM2.8916,14.83691c.07617.73047.54297,1.49512,1.24609,2.0459,1.21484.94727,2.84375,1.03125,3.55664.18066.33691-.40234.36621-.87793.33203-1.20703-.07715-.73047-.54297-1.49414-1.24707-2.04492-.65137-.50977-1.42188-.76953-2.10645-.76953-.59082,0-1.11914.19434-1.4502.58887-.33594.40137-.36523.87793-.33105,1.20605Z"
      fill="currentColor"
    />
  </svg>`;
};
